import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  appBar: {
    color: "white",
    backgroundColor: "#181818",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
  },
  text: {
    fontSize: "2rem",
    textAlign: "center",
    fontFamily: "Monoton",
  },
}));

export default useStyles;
